import React, { createContext, useState, useContext, useMemo } from 'react';
import axios from 'axios';

const BillingContext = createContext();

const INITIAL = { webJWT: null, role: null, tenantId: null, isAuthenticated: false };

export const BillingProvider = ({ children }) => {
  const [session, setSession] = useState(INITIAL);

  const setBillingSession = ({ token, role, tenantId }) => {
    setSession({ webJWT: token, role, tenantId: tenantId || null, isAuthenticated: true });
  };

  const clearBillingSession = () => setSession(INITIAL);

  const billingAxios = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
    });
    if (session.webJWT) {
      instance.defaults.headers.common['Authorization'] = 'Bearer ' + session.webJWT;
    }
    let redirecting = false;
    instance.interceptors.response.use(
      response => response,
      error => {
        if (error?.response?.status === 401 && !redirecting) {
          redirecting = true;
          clearBillingSession();
          window.location.replace('/billing?expired=1');
        }
        return Promise.reject(error);
      }
    );
    return instance;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.webJWT]);

  return (
    <BillingContext.Provider
      value={{ ...session, setBillingSession, clearBillingSession, billingAxios }}
    >
      {children}
    </BillingContext.Provider>
  );
};

export const useBilling = () => useContext(BillingContext);
